import { Button, Typography } from 'omakase';
import { Container } from 'ui';
import { IconMapMarker } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { core } from '@tock/coretypes';
import { guestImageUrl } from '@tock/images';
import { useActions } from '@tock/shared/utils/connect';
import AchievementsBar from 'components/profile/achievements/AchievementsBar';
import CircleImage from 'components/profile/CircleImage';
import IconPin from 'components/icons/svgr/IconPin';

interface Props {
  patron: core.Patron;
  patronProfilePlaceDescription?: string;
  setAchievementsModalIsOpen(isOpen: boolean): void;
}

const ProfileHeader = ({
  patron,
  setAchievementsModalIsOpen,
  patronProfilePlaceDescription,
}: Props) => {
  const {
    actions: { patron: patronActions },
  } = useActions();

  return (
    <Container>
      <div className="Profile-header">
        <div className="Profile-headerContent">
          <div className="Profile-headerText">
            <div className="Profile-name">
              <Typography
                variant="heading01"
                component="h1"
              >{`${patron.firstName} ${patron.lastName}`}</Typography>
            </div>
            {patronProfilePlaceDescription && (
              <div className="Profile-cityText">
                <IconMigrationUtil
                  legacyIcon={<IconPin className="Profile-cityIcon" />}
                  newIcon={<IconMapMarker className="Profile-cityIcon" />}
                />
                <Typography component="span" variant="body01">
                  {patronProfilePlaceDescription}
                </Typography>
              </div>
            )}
            <AchievementsBar setAchievementsModalIsOpen={setAchievementsModalIsOpen} />
            <div className="Profile-editButton">
              <Button
                variant="basic"
                size="medium"
                aria-haspopup={true}
                onClick={patronActions.openEditPatronProfileModal}
                data-testid="edit-profile-button"
              >
                Edit<span className="Profile-editButton-desktopButtonCopy">&nbsp;profile</span>
              </Button>
            </div>
          </div>
          <CircleImage
            imageClassName="Profile-headerImage"
            imageUrl={guestImageUrl(patron.imageUrl, 400)}
          />
        </div>
      </div>
    </Container>
  );
};

export default ProfileHeader;
